<template>
  <div class="py-3" style="background-color: white">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center pb-3 px-5" style="border-bottom:#D6D5D5 solid 1px">
      <p class="mb-0" style="font-size:16px;font-weight:500">Chi tiết lỗi</p>
    </div>
    <!--    body-->
    <div class="px-5 row mt-5">
      <!--      information detail-->
      <div class="col-lg-5">
        <div>
          <p style="font-size:16px;font-weight:500">Thông tin chi tiết</p>
          <DetailInformation :configField="configInformationField"
                             :information="errorDetailInformation"></DetailInformation>
        </div>
        <!--      trạng thái lỗi-->
        <div>
          <p>Trạng thái</p>
          <span class="badge text-dark" :class="statusMap[status.value]?.class">{{
              status?.label
            }}</span>
          <p class="mt-2" style="color: red" v-if="status?.label==='Hủy'">Lí do hủy tác vụ: {{ cancelReason }} </p>
        </div>
      </div>
      <!--      kết quả xử lý và nhập xử lý-->
      <div class="col-lg-7">
        <div class="w-100">
          <p style="font-size:16px;font-weight:500">Nhập kết quả xử lý</p>
          <HandlingResultSelect :errorType="errorType" :solutionOption="solutionOption"
                                @getApiReload="getApiReload"></HandlingResultSelect>
        </div>
        <div class="w-100 mt-5">
          <p style="font-size:16px;font-weight:500">Lịch sử xử lý</p>
          <HandleHistory :historyList="historyList"></HandleHistory>
        </div>

      </div>

    </div>
  </div>
</template>
<script>

import DetailInformation from "./detail-information/DetailInformation.vue";
import HandlingResultSelect from "./handling-result-select/HandlingResultSelect.vue";
import HandleHistory from "./handle-history/HandleHistory.vue";
import {
  GET_DETAIL_ERROR,
  GET_HANDLE_HISTORY,
  GET_ISSUES_OF_QUALITY
} from "../../../../core/services/store/report-error/reportError.module";
import {INFORMATION_CONFIG_LIST} from "../../../../core/option/leaderRadarOption";
import {formatDate, formatDateTime, formatDateTimeAsia} from "../../../../core/filters";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";

export default {
  name: "ErrorDetail",
  components: {HandleHistory, HandlingResultSelect, DetailInformation},
  data() {
    return {
      configInformationField: [],
      errorDetailInformation: {},
      errorType: null,
      solutionOption: [],
      historyList: [],
      status: {value: null, label: ''},
      statusMap: {
        0: {label: 'Cần xử lý', class: 'badge badge-warning text-dark'},
        1: {label: 'Đã xử lý', class: 'badge badge-primary'},
        2: {label: 'Hoàn thành', class: 'badge badge-success'},
        3: {label: 'Hủy', class: 'badge badge-secondary'}
      },
      cancelReason: ''
    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý giảng viên", route: "error-list"},
      {title: "Chi tiết lỗi"},
    ]);
    const loading = this.$loading({
      lock: true,
      text: 'Đang tải...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await this.getApiDetailError()
      await this.getApiSolutionOption()
      await this.getApiHistory()
    } catch (e) {

    } finally {
      loading.close();
    }


  },
  methods: {
    async getApiDetailError() {
      const response = await this.$store.dispatch(GET_DETAIL_ERROR, this.$route.params.id)
      const data = response?.data
      this.status = {value: data?.status, label: data?.status_label}
      this.cancelReason = data?.cancel_reason
      this.errorType = data?.metric_type
      this.configInformationField = INFORMATION_CONFIG_LIST[data?.metric_type]
      this.errorDetailInformation = {
        code: data?.id,
        metric: data?.metric_label,
        lecturer: data?.teacher,
        standard: data?.standard_text,
        standardClassRatio: data?.class_rate?.display,
        timeRange: `${formatDate(data?.measure_from)} - ${formatDate(data?.measure_to)}`,
        reportTime: formatDateTime(data?.reported_at),
        deadline: formatDate(data?.deadline_at),
        failedClasses: data?.failed_classes.map((item) => `${item?.class_name}: ${item?.percent_achieved ?? 0}%`).join('\n'),
        lecturerGroup: data?.teacher_group_name,
        className: data?.class_name,
        errorShiftRatio: data?.metric_value,
        finalPassRatio: data?.metric_value,
        midtermPassRatio: data?.metric_value,
        failedLecturers: data?.failed_teachers
          ?.map(teacher =>
            `${teacher?.teacher_id} - ${teacher?.teacher_name}: ${teacher?.error_rate ?? 0}% (${teacher?.error_session_count ?? 0}/${teacher?.session_total_count ?? 0})`
          )
          .join('\n') ?? ''
      }
    },
    async getApiSolutionOption() {
      try {
        const response = await this.$store.dispatch(GET_ISSUES_OF_QUALITY, this.$route.params.id)
        this.solutionOption = response?.data?.map((solution) => ({...solution, value: solution?.id})) ?? []
      } catch (e) {

      }
    },
    async getApiHistory() {
      try {
        const response = await this.$store.dispatch(GET_HANDLE_HISTORY, this.$route.params.id)
        this.historyList =
            (response?.data ?? []).map(item => ({
                  ...item,
                  created_at: formatDateTimeAsia(item?.created_at),
                  measurement_range_from: formatDate(item?.measurement_range?.from),
                  measurement_range_to: formatDate(item?.measurement_range?.to),
                  result_at: formatDateTime(item?.result_at),
                }))
      } catch (e) {

      } finally {

      }

    },
    async getApiReload() {
      const loading = this.$loading({
        lock: true,
        text: 'Đang tải...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        await this.getApiDetailError()
        await this.getApiHistory()
      } catch (e) {

      } finally {
        loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>